var map = {
	"app/admin/admin.module": [
		"../../../../../src/app/admin/admin.module.ts",
		"common",
		"admin.module"
	],
	"app/frontend/frontend.module": [
		"../../../../../src/app/frontend/frontend.module.ts",
		"common",
		"frontend.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// D:/PROJECTS/ANGULAR2_PROJECT/WEB/raspab/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main